export const PUBLIC_DIALOGUE_VIDEO_FALLBACK = {
  1: {
    topic: { fr: 'Santé', de: 'Gesundheit', en: 'Health' },
    title: { fr: 'Aller chez le dentiste', de: 'Zum Zahnarzt gehen', en: 'Go to the dentist' },
    guid: { fr: 'e4c0f8fc-c934-4016-8350-37284bfb25f5', de: '1883c3ac-496f-46e0-bee2-da93e2d136c8' },
    uploadDate: '2026-04-14',
  },
  2: {
    topic: { fr: 'Santé', de: 'Gesundheit', en: 'Health' },
    title: { fr: 'Consulter le médecin de famille', de: 'Den Hausarzt aufsuchen', en: 'Visit the family doctor' },
    guid: { fr: '466688c7-bae6-4d4b-a41a-cb88c8272e89', de: 'ae39ba8b-a181-43a3-bfa9-2796e4f761b7' },
    uploadDate: '2026-04-14',
  },
  3: {
    topic: { fr: 'Santé', de: 'Gesundheit', en: 'Health' },
    title: {
      fr: 'Acheter un médicament sans ordonnance médicale',
      de: 'Medikamente ohne Rezept kaufen',
      en: 'Buy medicine without a prescription',
    },
    guid: { fr: '974e2355-1952-4bc3-8e68-0db453dfc734', de: 'e3c379b0-90a1-4c34-a7db-811b922aa2ba' },
    uploadDate: '2026-04-14',
  },
  4: {
    topic: { fr: 'Santé', de: 'Gesundheit', en: 'Health' },
    title: { fr: 'Aller aux services des urgences', de: 'In die Notaufnahme gehen', en: 'Go to the emergency room' },
    guid: { fr: 'da0ddddd-d912-4605-86d4-b8a648fbbb92', de: '03059f57-d3e7-441c-92cd-b4f182b73361' },
    uploadDate: '2026-04-14',
  },
  5: {
    topic: { fr: 'Santé', de: 'Gesundheit', en: 'Health' },
    title: { fr: 'Consulter la sage-femme', de: 'Die Hebamme konsultieren', en: 'See the midwife' },
    guid: { fr: '0c9f501e-1b3e-4559-a449-71d5898bd285', de: '0317fdda-8509-4636-b64b-56c491d6fb03' },
    uploadDate: '2026-04-14',
  },
  19: {
    topic: { fr: 'Logement', de: 'Wohnen', en: 'Housing' },
    title: {
      fr: 'Résilier le bail de son appartement',
      de: 'Den Mietvertrag kündigen',
      en: 'Terminate the apartment lease',
    },
    guid: { fr: 'b128dbb9-1e2f-478d-b9a3-20e7217e0c0a', de: 'fe144d29-510f-4692-8a87-1bc174eea264' },
    uploadDate: '2026-04-14',
  },
  20: {
    topic: { fr: 'Logement', de: 'Wohnen', en: 'Housing' },
    title: { fr: "Demander d'effectuer une réparation", de: 'Eine Reparatur beantragen', en: 'Request a repair' },
    guid: { fr: '5b546485-f5ca-41fc-a295-78ea634b3dd3', de: 'f51f9843-2006-441e-ab78-c8b4923da7fd' },
    uploadDate: '2026-04-14',
  },
  21: {
    topic: { fr: 'Logement', de: 'Wohnen', en: 'Housing' },
    title: {
      fr: 'Chercher et louer un appartement',
      de: 'Eine Wohnung suchen und mieten',
      en: 'Search for and rent an apartment',
    },
    guid: { fr: '4aba1bca-1056-4e2b-8605-414bc45dfb9f', de: 'f86a3373-226e-4b83-a1ed-6bcd216db889' },
    uploadDate: '2026-04-14',
  },
  22: {
    topic: { fr: 'Logement', de: 'Wohnen', en: 'Housing' },
    title: {
      fr: "Participer à l'entraînement pour la première fois",
      de: 'Zum ersten Mal am Training teilnehmen',
      en: 'Join a training session for the first time',
    },
    guid: { fr: 'ad1f9cbc-6448-4de6-9b43-84deaaa3576b', de: '994577f4-3127-4bfa-8b00-ee2883f2478a' },
    uploadDate: '2026-04-14',
  },
  23: {
    topic: { fr: 'Logement', de: 'Wohnen', en: 'Housing' },
    title: {
      fr: 'Trouver une association ou un club pour ses loisirs',
      de: 'Einen Verein oder Club für Freizeitaktivitäten finden',
      en: 'Find a club or association for hobbies',
    },
    guid: { fr: 'bddbdc19-eb84-4a03-8869-3d68d529b303', de: 'fd242b63-a67e-4d53-9c93-05bcd601ae1e' },
    uploadDate: '2026-04-14',
  },
  68: {
    topic: { fr: 'Travail', de: 'Arbeit', en: 'Work' },
    title: {
      fr: "Nettoyer la chambre d'un résident en EMS",
      de: 'Das Zimmer eines Bewohners im Pflegeheim reinigen',
      en: 'Clean a resident’s room in a nursing home',
    },
    guid: { fr: 'b225af0f-73a6-4d22-b116-027f4ef87004', de: 'bd44b5b5-ac70-4211-a1e9-0ae03a489205' },
    uploadDate: '2026-04-14',
  },
  69: {
    topic: { fr: 'Travail', de: 'Arbeit', en: 'Work' },
    title: {
      fr: 'Servir des clients dans un restaurant',
      de: 'Kunden in einem Restaurant bedienen',
      en: 'Serve customers in a restaurant',
    },
    guid: { fr: 'e6d52864-70e1-4b50-9150-95641bd19755', de: '0333126f-d6e0-4121-94b7-722698e5f0aa' },
    uploadDate: '2026-04-14',
  },
  70: {
    topic: { fr: 'Travail', de: 'Arbeit', en: 'Work' },
    title: {
      fr: 'Dispenser des soins à un résident en EMS',
      de: 'Einem Bewohner im Pflegeheim Pflege leisten',
      en: 'Provide care to a nursing home resident',
    },
    guid: { fr: 'd3214378-3e7c-4c14-a032-208e8362840c', de: '82198e63-c391-4c30-805b-fad3b7506cf8' },
    uploadDate: '2026-04-14',
  },
  71: {
    topic: { fr: 'Travail', de: 'Arbeit', en: 'Work' },
    title: { fr: 'Recevoir son congé', de: 'Die Kündigung erhalten', en: 'Receive one’s notice' },
    guid: { fr: '9db61e81-9c22-4f5b-84e6-6439c2324889', de: '1c420906-4449-4355-8554-15ba618004ce' },
    uploadDate: '2026-04-14',
  },
  72: {
    topic: { fr: 'Travail', de: 'Arbeit', en: 'Work' },
    title: { fr: 'Donner son congé', de: 'Selbst kündigen', en: 'Resign from one’s job' },
    guid: { fr: '67d22176-a432-4b16-a6e4-330bcfc6a78e', de: '35d67997-5a04-4cda-96d1-f901debf8ae4' },
    uploadDate: '2026-04-14',
  },
};

export const getPublicDialogueVideoFallback = (scenarioId) => {
  const numericScenarioId = Number(scenarioId);
  if (!Number.isInteger(numericScenarioId)) {
    return null;
  }

  return PUBLIC_DIALOGUE_VIDEO_FALLBACK[numericScenarioId] || null;
};
